export const STUDENT_PAYMENTS = '/student_payment/'
export const STUDENT_PAYMENTS_BY_STUDENT = `${STUDENT_PAYMENTS}student/` as const
export const STUDENT_PAYMENTS_PRINCIPAL = `${STUDENT_PAYMENTS}student/all` as const

export const ONE_C = '/onec/'
export const ONE_C_CONTRACTS = `${ONE_C}contracts` as const
export const ONE_C_CONTRACTS_STUDENT = `${ONE_C_CONTRACTS}/student` as const
export const ONE_C_SALARY_STAFF = `${ONE_C}salary/staff` as const
